import axios from "@/util/axios";

export default {


    /* 保存一条信息 */
    saveSubmit: (data) => axios.post({url: "/order/common/mini/saleFeedback/saveSubmit", data: data}),

    /* 查询列表 */
    queryList: (data) => axios.get({url: "/order/common/mini/saleFeedback/queryList", data: data}),

    /* 查询统计信息 */
    countFeedback: () => axios.get("/order/common/mini/saleFeedback/countFeedback"),

    /* 查询一条信息 */
    findById: (id) => axios.get({url: "/order/common/mini/saleFeedback/findById", data:{id}}),

    saveReply: (id, reply) => axios.get({url: "/order/common/mini/saleFeedback/toSaveReply", data:{id, reply}}),
}